import React, { useState, useEffect } from 'react';
import {
    Row,
    Col,
    Button,
    Card,
    Input,
    Form,
    Select,
    Radio,
    DatePicker,
    Space,
} from 'antd';
import moment from 'moment';
import nationality from '../../JSON/nationality.json';
import initialJson from '../../JSON/initials.json';
import { useDispatch, useSelector } from 'react-redux';
import { addNewFamilyRequest, getCountriesRequest } from './Actions';
import { selectCountryDetails, selectLoading, selectSuccessfullyFamilyAdded } from './Selectors';
import { useNavigate } from 'react-router-dom';
import CustomSpin from '../CommonSpin';
import { BodyTextHeading } from '../CommonText';
// import dayjs from 'dayjs';

import english from '../../Translations/English.json';
import hindi from '../../Translations/Hindi.json';
import malayalam from '../../Translations/Malayalam.json';

const { Option } = Select;
const dateFormat = 'DD-MM-YYYY';
const RadioGroup = Radio.Group;

const AddFamilyTree = () => {
    const [selectedInitials, setSelectedInitials] = useState('Mr.');

    const [form] = Form.useForm(); // useForm hook
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const requesting = useSelector(selectLoading);
    const countries = useSelector(selectCountryDetails);    
    const successAdd = useSelector(selectSuccessfullyFamilyAdded);

    const langid = localStorage.getItem('INTL') ? (localStorage.getItem('INTL')) : 'en';
    const langdata = langid && langid == 'en' ? english : langid == 'ma' ? malayalam : langid == 'hin' ? hindi : english;

    if(successAdd) {
        navigate('/familytree');
    }

    useEffect(() => {
        dispatch(getCountriesRequest());
    }, []);

    const handleSubmit = (value) => {
        dispatch(addNewFamilyRequest(value, selectedInitials));        
    };

    const disabledDate = (current) => {
        return current > moment().subtract(1, 'days').endOf('day');
    };

    const validator = (rule, value) => {
        if (value && value.length < 3) {
            return Promise.reject('First Name should be more than three letters');
        }
        return Promise.resolve();
    };

    const onSelect = (value, abc) => {
        localStorage.setItem('COUNTRY_CODE', abc.props.abc);
    };

    const nationa = nationality.map((item, i) => (
        <Option key={i} value={item}>
            {item}
        </Option>
    ));

    const country = countries?.map((item, i) => (
        <Option key={i} value={item.name} abc={item.countryCallingCodes[0]}>
            {item.name}
        </Option>
    ));

    const selectInitials = initialJson.map((itm) => (
        <Option key={itm} value={itm}>
            {itm}
        </Option>
    ));

    const handleInitials = (value) => {
        setSelectedInitials(value);
    };


    // const initialSelect = (
    //     <Select value={selectedInitials} onChange={handleInitials} style={{ width: '400%' }}>
    //         {selectInitials}
    //     </Select>
    // );

    return (
        <div style={{ paddingBottom: '20px' }}>
            <Row type="flex" justify="center" style={{ marginTop: '10px' }}>
                <Col xs={{ span: 22 }} md={{ span: 14 }} lg={{ span: 16 }} xl={{ span: 16 }} xxl={{ span: 16 }}>
                    <Card style={{ boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.04)', borderRadius: '4px' }}>
                        <div style={{ marginBottom: '20px' }}><BodyTextHeading  text = {`${langdata.PatientsDetails ? langdata.PatientsDetails : 'Patients Details' }`} /></div>
                        <Form form={form} onFinish={handleSubmit}>
                            <Form.Item label={`${langdata.Relationship ? langdata.Relationship : 'Relationship' }`} hasFeedback name="relationship" rules={[{ required: true, message: 'Please select your relationship!' }]}>
                                <Select placeholder={`${langdata.Pleaseselectrelationship ? langdata.Pleaseselectrelationship : 'Please select relationship' }`}>
                                    <Option value={'Father'}>Father</Option>
                                    <Option value={'Mother'}>Mother</Option>
                                    <Option value={'Husband'}>Husband</Option>
                                    <Option value={'Wife'}>Wife</Option>
                                    <Option value={'Son'}>Son</Option>
                                    <Option value={'Daughter'}>Daughter</Option>
                                    <Option value={'Other'}>Other</Option>
                                </Select>
                            </Form.Item>

                            <Form.Item label={`${langdata.FirstName ? langdata.FirstName : 'First Name' }`} hasFeedback name="firstName" rules={[{ required: true, message: 'Please input your First Name', whitespace: true }, { validator }]}>
                                <Space.Compact style={{ display : 'flex'}} >
                                    <Select value={selectedInitials} onChange={handleInitials} style={{ width: '100px' }}>
                                        {selectInitials}
                                    </Select>
                                    <Input placeholder={`${langdata.FirstName ? langdata.FirstName : 'First Name' }`} style={{ width: '100%' }} />
                                </Space.Compact>
                                {/* <Input addonBefore={initialSelect} placeholder="First Name" /> */}
                            </Form.Item>

                            <Form.Item label={`${langdata.LastName ? langdata.LastName : 'Last Name' }`} hasFeedback name="lastName" rules={[{ required: true, message: 'Please input your Last Name', whitespace: true }]}>
                                <Input placeholder={`${langdata.LastName ? langdata.LastName : 'Last Name' }`} />
                            </Form.Item>

                            <Form.Item label={`${langdata.Gender ? langdata.Gender : 'Gender' }`} hasFeedback name="gender" rules={[{ required: true, message: 'Please Select Gender!' }]}>
                                <RadioGroup style={{ paddingRight: '15px' }}>
                                    <Radio value={'Male'}>{`${langdata.Male ? langdata.Male : 'Male' }`}</Radio>
                                    <Radio value={'Female'}>{`${langdata.Female ? langdata.Female : 'Female' }`}</Radio>
                                    <Radio value={'Others'}>{`${langdata.Others ? langdata.Others : 'Others' }`}</Radio>
                                </RadioGroup>
                            </Form.Item>

                            <Form.Item label={`${langdata.PresentAddress ? langdata.PresentAddress : 'Present Address' }`} hasFeedback name="address" rules={[{ required: true, message: 'Please input your Address', whitespace: true }]}>
                                <Input placeholder={`${langdata.PresentAddress ? langdata.PresentAddress : 'Present Address' }`} />
                            </Form.Item>

                            <Form.Item label={`${langdata.Nationality ? langdata.Nationality : 'Nationality' }`} hasFeedback name="Country" rules={[{ required: false, message: 'Please select your Nationality!' }]}>
                                <Select showSearch placeholder={`${langdata.PleaseselectaNationality ? langdata.PleaseselectaNationality : 'Please select a Nationality' }`} optionFilterProp="children" filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {nationa}
                                </Select>
                            </Form.Item>

                            <Form.Item label={`${langdata.CountryofResidence ? langdata.CountryofResidence : 'Country of Residence'  }`} hasFeedback name="resident" rules={[{ required: false, message: 'Please select your Country of Residence!' }]}>
                                <Select
                                    showSearch
                                    onSelect={onSelect}
                                    placeholder={`${langdata.PleaseselectCountryofResidence ? langdata.PleaseselectCountryofResidence : 'Please select Country of Residence' }`}
                                    optionFilterProp="children"
                                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                >
                                    {country}
                                </Select>
                            </Form.Item>

                            <Form.Item label={`${langdata.BloodGroup ? langdata.BloodGroup : 'Blood Group' }`} hasFeedback name="bloodGroup" rules={[{ required: false, message: 'Please select your Blood Group!' }]}>
                                <Select placeholder={`${langdata.PleaseselectBloodGroup ? langdata.PleaseselectBloodGroup : 'Please select Blood Group' }`}>
                                    <Option value={'A+'}>A+</Option>
                                    <Option value={'A-'}>A-</Option>
                                    <Option value={'B+'}>B+</Option>
                                    <Option value={'B-'}>B-</Option>
                                    <Option value={'O+'}>O+</Option>
                                    <Option value={'O-'}>O-</Option>
                                    <Option value={'AB+'}>AB+</Option>
                                    <Option value={'AB-'}>AB-</Option>
                                    <Option value={'Not Specified'}>Not Specified</Option>
                                </Select>
                            </Form.Item>

                            <Form.Item label={`${langdata.DateofBirth ? langdata.DateofBirth : 'Date of Birth'}`} name="dateOfBirth" rules={[{ required: true, message: 'Please select your Date of Birth!' }]}>
                                <DatePicker disabledDate={disabledDate} format={dateFormat} placeholder={`${langdata.DateofBirth ? langdata.DateofBirth : 'Date of Birth'}`}/>
                            </Form.Item>

                            <Form.Item>
                                <Button style={{ marginRight: '8px' }} onClick={() => navigate('/familytree')}>
                                    {`${langdata.Cancel ? langdata.Cancel : 'Cancel' }`}
                                </Button>
                                <Button type="primary" htmlType="submit">
                                    {`${langdata.Register ? langdata.Register : 'Register' }`}
                                </Button>
                            </Form.Item>
                        </Form>
                    </Card>
                </Col>
            </Row>
            <CustomSpin spinning={requesting} />            
        </div>
    );
};


export default AddFamilyTree;
